$(document).ready(function () {

    /**
     * When the side panel is shown, the event 'nc.sidePanel.shown' is triggered.
     */
    this.sidePanelShowHandler = function () {
        // Stop if the page does not contain the element with id 'new-goods-delivery-form'
        if (document.getElementById('new-goods-delivery-form')) return;

        /**
         * Add a new batch line to the sales order line.
         * After that reset the input fields.
         *
         * @param salesOrderlineId
         */
        function addBatchLine(salesOrderlineId) {

            // Get the HTML of the batch line.
            let selectHtml = $('.salesorder-line[data-salesorder-line-id="' + salesOrderlineId + '"] .batch-select').html();

            // Remove the class 'd-none' from the HTML.
            selectHtml = selectHtml.replace('d-none', '');

            // Append the HTML to the sales order line.
            $('.salesorder-line[data-salesorder-line-id="' + salesOrderlineId + '"] .product-batches').append(selectHtml);

            // Reassign the batch id to the batch line form fields.
            resetInputFields(salesOrderlineId);

            // Make sure that the new batch line can be deleted when the delete button is clicked.
            $('#create-goods-delivery-form .button-delete-batch').off('click').on('click', function(e) {
                e.preventDefault();

                // Remove the batch line.
                $(this).closest('.product-batch').remove();

                // Reassign the batch id to the batch line form fields.
                resetInputFields(salesOrderlineId);
            });
        }

        /**
         * Reassign the batch id to the batch line form fields.
         *
         * @param salesOrderlineId
         */

        function resetInputFields(salesOrderlineId) {
            let $i = 0;

            // Batch id field.
            $i = 0;
            $('.salesorder-line[data-salesorder-line-id="' + salesOrderlineId + '"] .batch_id-input').each(function() {
                $(this).attr('name', 'batch_id[' + salesOrderlineId + '][' + ($i - 1) + ']');
                $i++;
            });

            // Quantity field.
            $i = 0;
            $('.salesorder-line[data-salesorder-line-id="' + salesOrderlineId + '"] .quantity-input').each(function() {
                $(this).attr('name', 'quantity[' + salesOrderlineId + '][' + ($i - 1) + ']');
                $i++;
            });

            // Batch tracking number field.
            $i = 0;
            $('.salesorder-line[data-salesorder-line-id="' + salesOrderlineId + '"] .batch_tracking_number-input').each(function() {
                $(this).attr('name', 'batch_tracking_number[' + salesOrderlineId + '][' + ($i - 1) + ']');
                $i++;
            });

            // Notes field.
            $i = 0;
            $('.salesorder-line[data-salesorder-line-id="' + salesOrderlineId + '"] .notes-input').each(function() {
                $(this).attr('name', 'notes[' + salesOrderlineId + '][' + ($i - 1) + ']');
                $i++;
            });
        }

        /**
         * Add a new batch line to the sales order.
         */
        $('#create-goods-delivery-form .button-add-batch').on('click', function(e) {
            e.preventDefault();

            addBatchLine(
                $(this).parents('.salesorder-line').data('salesorder-line-id'),
            );
        });

        // Always add the first bath line when the side panel is shown.
        $('#create-goods-delivery-form .button-add-batch').click();
    }

    // When the side panel is shown, the event 'nc.sidePanel.shown' is triggered.
    $(document).on('nc.sidePanel.shown', this.sidePanelShowHandler);
});
